import { render, staticRenderFns } from "./LeadDetailItems.vue?vue&type=template&id=3e34b03d&scoped=true"
import script from "./LeadDetailItems.vue?vue&type=script&lang=js"
export * from "./LeadDetailItems.vue?vue&type=script&lang=js"
import style0 from "./LeadDetailItems.vue?vue&type=style&index=0&id=3e34b03d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e34b03d",
  null
  
)

export default component.exports